export default "__VITE_ASSET__D$dwtfkL__"